import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { DebitNoteMasterCreateRequestDTO, DebitNoteMasterDeleteRequestDTO, DebitNoteMasterDTO, DebitNoteMasterList, DebitNoteMasterReadByTenantIdRequestDTO, DebitNoteMasterReadByIdRequestDTO, DebitNoteMasterSearchByDebitNoteNoRequestDTO, DebitNoteMasterUpdateRequestDTO } from "./debit-note-master.interface";
import { DebitNoteMaster_Create, DebitNoteMaster_Delete, DebitNoteMaster_ReadByTenantId, DebitNoteMaster_ReadById, DebitNoteMaster_SearchByDebitNoteNo, DebitNoteMaster_Update, DebitNoteOtherCharges_create, DebitNoteOtherCharges_delete, DebitNoteOtherCharges_readAll, DebitNoteOtherCharges_readByDebitNoteId, DebitNoteOtherCharges_readById, DebitNoteOtherCharges_update } from "src/app/GlobalVariables";
import { Observable } from "rxjs";
import { DebitNoteOtherChargesCreateRequestDTO, DebitNoteOtherChargesDeleteRequestDTO, DebitNoteOtherChargesDTO, DebitNoteOtherChargesList, DebitNoteOtherChargesReadByDebitNoteIdRequestDTO, DebitNoteOtherChargesReadByIdRequestDTO, DebitNoteOtherChargesUpdateRequestDTO } from "./debitnoteothercharges.interface";


@Injectable({
    providedIn: 'root'
})
export class DebitNoteService {

    constructor() { }
    http = inject(HttpClient)

    DebitNoteMaster_Create(data: DebitNoteMasterCreateRequestDTO): Observable<DebitNoteMasterDTO> {
        return this.http.post<DebitNoteMasterDTO>(DebitNoteMaster_Create, data)
    }

    DebitNoteMaster_Update(data: DebitNoteMasterUpdateRequestDTO): Observable<DebitNoteMasterDTO> {
        return this.http.post<DebitNoteMasterDTO>(DebitNoteMaster_Update, data)
    }

    DebitNoteMaster_Delete(data: DebitNoteMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(DebitNoteMaster_Delete, data)
    }

    DebitNoteMaster_ReadById(data: DebitNoteMasterReadByIdRequestDTO): Observable<DebitNoteMasterDTO> {
        return this.http.post<DebitNoteMasterDTO>(DebitNoteMaster_ReadById, data)
    }

    DebitNoteMaster_ReadByTenantId(data: DebitNoteMasterReadByTenantIdRequestDTO): Observable<DebitNoteMasterList> {
        return this.http.post<DebitNoteMasterList>(DebitNoteMaster_ReadByTenantId, data)
    }

    DebitNoteMaster_SearchByDebitNoteNo(data: DebitNoteMasterSearchByDebitNoteNoRequestDTO): Observable<DebitNoteMasterList> {
        return this.http.post<DebitNoteMasterList>(DebitNoteMaster_SearchByDebitNoteNo, data)
    }

    //DebitNote Other Charges

    DebitNoteOtherCharges_create(data: DebitNoteOtherChargesCreateRequestDTO): Observable<DebitNoteOtherChargesDTO > {
        return this.http.post<DebitNoteOtherChargesDTO>(DebitNoteOtherCharges_create, data)
    }
    DebitNoteOtherCharges_update(data: DebitNoteOtherChargesUpdateRequestDTO): Observable<DebitNoteOtherChargesDTO> {
        return this.http.post<DebitNoteOtherChargesDTO>( DebitNoteOtherCharges_update, data)
    }
     DebitNoteOtherCharges_delete(data: DebitNoteOtherChargesDeleteRequestDTO): Observable<void> {
        return this.http.post<void>( DebitNoteOtherCharges_delete, data)
    }
    DebitNoteOtherCharges_readById(data: DebitNoteOtherChargesReadByIdRequestDTO): Observable<DebitNoteOtherChargesDTO> {
        return this.http.post<DebitNoteOtherChargesDTO>(DebitNoteOtherCharges_readById, data)
    }
   DebitNoteOtherCharges_readByDebitNoteId(data: DebitNoteOtherChargesReadByDebitNoteIdRequestDTO): Observable<DebitNoteOtherChargesList> {
        return this.http.post<DebitNoteOtherChargesList>(DebitNoteOtherCharges_readByDebitNoteId, data)
    }
    DebitNoteOtherCharges_readAll(): Observable<DebitNoteOtherChargesList> {
        return this.http.get<DebitNoteOtherChargesList>(DebitNoteOtherCharges_readAll);
    }

}